<div #pageContainer class="w-full">
    <form [formGroup]="searchForm">
        <app-table-filter [searchForm]="searchForm" class="text-primary" (searchTriggered)="handleSearch($event)"></app-table-filter>

        <div class="grid grid-cols-1 sm:grid-cols-3">
            <div class="flex justify-start col-span-2">
                <div class="w-19 ml-2">
                    <mat-form-field class="w-full no-bottom-gap mb-2">
                        <mat-select formControlName="PageSize">
                            <mat-option [value]="10"> 10 </mat-option>
                            <mat-option [value]="20"> 20 </mat-option>
                            <mat-option [value]="50"> 50 </mat-option>
                            <mat-option [value]="100"> 100 </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <app-sort-menu class="mx-2" [columns]="columnSort" [orderDir]="'asc'" [initialOrderKeys]="[]"
                    (apply)="applySort($event)">
                </app-sort-menu>

                <button class="btn btn-outline btn-default dt-download" matTooltip="Download Records" (click)="downloadCMRecords()">
                    <mat-icon class="text-primary hover:text-white"
                        svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                </button>
            </div>
            <div class="flex justify-end">
                <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                    Search
                </button>
                <button class="btn btn-outline btn-default" (click)="reset()">
                    Reset
                </button>
                <button class="btn btn-outline btn-default mx-2 hover:text-white" matTooltip="Refresh Table"
                    (click)="setPage({ offset: dt.page.offset })">
                    <mat-icon class="text-primary hover:text-white" svgIcon="heroicons_solid:arrow-path"></mat-icon>
                </button>
            </div>

            <div class="flex justify-start col-span-2">
                <span class="self-center font-medium text-gray-400 italic text-md p-2">
                    Sorting by {{ sortInfo }}
                </span>
            </div>

            <div class="flex justify-end">
                <span class="self-center font-medium text-primary text-md p-2">
                    {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </span>
            </div>
        </div>
    </form>

    <div class="overflow-x-auto">
        <div class="grid overflow-x-auto">
            <!-- Header -->
            <div class="table-cm-baseline-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                matSort matSortDisableClear>
                <div class="border py-8 text-center">
                    No
                </div>

                <div [mat-sort-header]="'fieldLongName'" class="flex justify-center border py-4 my-custom-sort-header">
                    Field
                </div>

                <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                    Platform
                </div>

                <div [mat-sort-header]="'wellLongName'" class="flex justify-center border py-4">
                    Well
                </div>

                <div [mat-sort-header]="'stringShortName'" class="flex justify-center border py-4">
                    Well String
                </div>

                <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                    String Indicator
                </div>

                <div [mat-sort-header]="'source'" class="flex border justify-center py-4">
                    Source
                </div>

                <div [mat-sort-header]="'submissionYear'" class="flex border justify-center py-4">
                    WPB Submission Year
                </div>

                <div [mat-sort-header]="'failureDate'" class="flex border justify-center py-4">
                    Failure Date
                </div>

                <div [mat-sort-header]="'failEquipment'" class="flex border justify-center py-4">
                    Failed Equipment
                </div>

                <div [mat-sort-header]="'problemReported'" class="flex border justify-center py-4">
                    Reported Problem
                </div>

                <div [mat-sort-header]="'riskRanking'" class="flex border justify-center py-4">
                    Risk Ranking
                </div>

                <div [mat-sort-header]="'forwardActionPlan'" class="flex border justify-center py-4">
                    Forward Action Plan
                </div>

                <div [mat-sort-header]="'detailDesc'" class="flex border justify-center py-4">
                    Description
                </div>

                <div [mat-sort-header]="'rectifiedDate'" class="flex border justify-center py-4">
                    Rectified Date
                </div>

                <div [mat-sort-header]="'status'" class="flex border justify-center py-4">
                    Status
                </div>

                <div class="block border text-center py-8">
                    Action
                </div>

            </div>
            <!-- Rows -->
            <ng-container *ngIf="dt.rows.length; else noRecords">
                <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                    <div class="table-cm-baseline-record-grid  grid items-center border-b"
                        [ngClass]="{'bg-primary-100': i % 2 }">

                        <!-- No -->
                        <div class="py-4 text-center">
                            {{startingIndex + i + 1}}.
                        </div>

                        <!-- Field Long Name -->
                        <div class="flex truncate justify-center">
                            {{ row.fieldLongName }}
                        </div>

                        <!-- Platform Long Name  -->
                        <div class="flex justify-center">
                            {{ row.platformLongName }}
                        </div>

                        <!-- Well Long Name  -->
                        <div class="flex justify-center">
                            {{ row.wellLongName }}
                        </div>

                        <!-- String Short Name  -->
                        <div class="text-center">
                            {{ row.stringShortName }}
                        </div>

                        <!-- String Indicator -->
                        <div class="block text-center">
                            {{ row.stringIndicatorShortName }}
                        </div>

                        <!-- Source -->
                        <div class="block text-center mx-2">
                            {{ row.source || '-' }}
                        </div>

                        <!-- WPB Submission Year -->
                        <div class="block text-center">
                            {{ row.submissionYear || '-' }}
                        </div>

                        <!-- Failure Date -->
                        <div class="block text-center">
                            {{ handleFormatDate(row.failureDate, false) || '-' }}
                        </div>

                        <!-- Failure Equipment -->
                        <div class="block text-center">
                            {{ row.failEquipment || '-' }}
                        </div>

                        <!-- Reported Problem -->
                        <div class="block text-center">
                            {{ row.problemReported || '-' }}
                        </div>

                        <!-- Risk Rangking -->
                        <div class="block text-center mx-2" [ngClass]="{
                                'risk0Badge': row.riskRanking?.toLowerCase() === 'healthy no risk',
                                'risk1Badge': row.riskRanking?.toLowerCase() === 'healthy low risk',
                                'risk2Badge': row.riskRanking?.toLowerCase() === 'healthy medium risk',
                                'risk3Badge': row.riskRanking?.toLowerCase() === 'unhealthy high risk',
                                'risk4Badge': row.riskRanking?.toLowerCase() === 'unhealthy very high risk',
                              }">
                            {{ row.riskRanking || '-' }}
                        </div>

                        <!-- Forward Action Plan -->
                        <div class="block text-center">
                            {{ row.forwardActionPlan || '-' }}
                        </div>

                        <!-- Description -->
                        <div class="block text-center">
                            {{ row.detailDesc || '-' }}
                        </div>

                        <!-- Rectified Date -->
                        <div class="block text-center">
                            {{ handleFormatDate(row.rectifiedDate, false) || '-' }}
                        </div>

                        <!-- Status-->
                        <div class="block text-center mx-2" [ngClass]="{
                                    'idleBadge': row.status == status.OPEN,
                                    'successBadge': row.status == status.APPROVED || row.status == status.CLOSED,
                                    'failedBadge': row.status == status.REJECTED,
                                    'warningBadge': row.status == status.READY
                              }">
                            {{ row.status || '-' }}
                        </div>

                        <!-- Action -->
                        <div class="block text-center">
                            <button class="btn btn-remove-bg px-0" (click)="editWpb(row)">
                                <mat-icon class="text-primary" [matTooltip]="row.wpbId ? 'Edit Work Planning Budget' : 'Create Work Planning Budget'"
                                    [svgIcon]="'heroicons_outline:currency-dollar'"></mat-icon>
                            </button>

                            <button class="btn btn-remove-bg"
                                [disabled]="row['status'] == status.APPROVED || row['status'] == status.CLOSED || row['status'] == status.REJECTED || (row['status'] == status.OPEN && row['source'] == 'FN' )"
                                (click)="editCM(row.id)">
                                <mat-icon class="text-primary" [svgIcon]="'heroicons_solid:pencil-square'" matTooltip="Edit"></mat-icon>
                            </button>

                            <button class="btn btn-remove-bg px-0" (click)="viewCM(row.id)">
                                <mat-icon class="text-primary" [svgIcon]="'heroicons_solid:eye'" matTooltip="View"></mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #noRecords>
                <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                    There are no records registered!
                </div>
            </ng-template>
        </div>

        <div
            class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
            <div class="content-center px-3">
                {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }} </div>

                    <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                        [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                        [hidePageSize]="true" [showFirstLastButtons]="true">
                    </mat-paginator>
            </div>
        </div>
    </div>